<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="6">
                <app-filtro-tabela
                    v-model="filtro"
                    v-if="mostrarFiltro"
                ></app-filtro-tabela>
            </b-col>
            <b-col sm="12" md="12" lg="6">
                <slot name="botoes"></slot>
            </b-col>
        </b-row>
        <b-table
            :striped="striped"
            :hover="hover"
            :bordered="bordered"
            :small="small"
            :responsive="true"
            :id="idTabela"
            :ref="idTabela"
            :items="itens"
            :fields="camposComCheckbox"
            empty-text="Não existem dados a serem exibidos"
            empty-filtered-text="Não existem dados a serem exibidos"
            :show-empty="mostrarVazio"
            :per-page="itensPorPaginaSelected"
            :current-page="paginaAtual"
            :filter="filtro"
            :filter-function="filtrar"
            :busy="emProcessamento"
            @filtered="onFiltered"
        >
            <template slot="HEAD_checkbox" v-if="mostrarCheckbox">
                <b-form-checkbox
                    :checked="todasSelecionadas"
                    :indeterminate="algumasSelecionadas"
                    @change="toggleSelecionarTodos"
                ></b-form-checkbox>
            </template>
            <template slot="checkbox" slot-scope="data" v-if="mostrarCheckbox">
                <b-form-checkbox
                    :checked="isItemSelecionado(data.item)"
                    @change="toggleSelecionarItem(data.item)"
                ></b-form-checkbox>
            </template>
            <template
                v-for="campo in campos"
                :slot="campo.key"
                slot-scope="data"
            >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'date'"
                    >{{
                        deepFind(data.item, campo.key)
                            ? $moment(deepFind(data.item, campo.key)).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}</slot
                >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'datetime'"
                    >{{
                        deepFind(data.item, campo.key)
                            ? $moment(deepFind(data.item, campo.key)).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : ''
                    }}</slot
                >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'status'"
                >
                    <app-status
                        :status="deepFind(data.item, campo.key)"
                    ></app-status>
                </slot>
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="mostrarPadrao(campo.type)"
                    >{{ deepFind(data.item, campo.key) }}</slot
                >
            </template>
            <template
                v-for="campo in campos"
                :slot="'FOOT_' + campo.key"
                slot-scope="data"
            >
                <slot :name="'FOOT_' + campo.key" v-bind="data"></slot>
            </template>
            <template
                v-for="campo in campos"
                :slot="'HEAD_' + campo.key"
                slot-scope="data"
            >
                <slot :name="'HEAD_' + campo.key" v-bind="data">{{
                    data.label
                }}</slot>
            </template>
        </b-table>
        <app-paginacao
            :totalItens="totalItens"
            :itensPorPagina="itensPorPaginaSelected"
            v-model="paginaAtual"
            v-if="itensPorPagina > 0"
        >
            <template slot="paginacao">
                <b-form-select
                    v-model="itensPorPaginaSelected"
                    :options="itensPorPaginaOptions"
                ></b-form-select>
            </template>
        </app-paginacao>
    </div>
</template>

<script>
import PaginacaoComponent from './PaginacaoComponent'
import FiltroTabelaComponent from './FiltroTabelaComponent'

export default {
    name: 'app-tabela',
    props: {
        idTabela: {
            type: String,
            default: 'appTabela'
        },
        itens: {
            type: Array
        },
        campos: {
            type: Array
        },
        itensPorPagina: {
            type: Number,
            default: 5
        },
        emProcessamento: {
            type: Boolean,
            default: false
        },
        mostrarFiltro: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        hover: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: true
        },
        small: {
            type: Boolean,
            default: true
        },
        mostrarCheckbox: {
            type: Boolean,
            default: false
        },
        propriedadeId: {
            type: String,
            default: 'id'
        }
    },
    data() {
        return {
            mostrarVazio: true,
            totalItens: 0,
            paginaAtual: 1,
            filtro: '',
            itensPorPaginaSelected: this.itensPorPagina,
            itensPorPaginaOptions: [
                { value: 5, text: 5 },
                { value: 10, text: 10 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            itensSelecionados: []
        }
    },

    computed: {
        camposComCheckbox() {
            if (!this.mostrarCheckbox) {
                return this.campos
            }
            return [
                {
                    key: 'checkbox',
                    label: '',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    thStyle: { width: '50px' },
                    tdStyle: { width: '50px' }
                },
                ...this.campos
            ]
        },
        itensPaginaAtual() {
            if (!this.itens || this.itens.length === 0) {
                return []
            }
            const inicio = (this.paginaAtual - 1) * this.itensPorPaginaSelected
            const fim = inicio + this.itensPorPaginaSelected
            return this.itens.slice(inicio, fim)
        },
        todasSelecionadas() {
            if (!this.mostrarCheckbox || !this.itens || this.itens.length === 0) {
                return false
            }
            return this.itens.every(item =>
                this.isItemSelecionado(item)
            )
        },
        algumasSelecionadas() {
            if (!this.mostrarCheckbox || !this.itens || this.itens.length === 0) {
                return false
            }
            const selecionados = this.itens.filter(item =>
                this.isItemSelecionado(item)
            )
            return selecionados.length > 0 && selecionados.length < this.itens.length
        },
        itensNaoSelecionados() {
            if (!this.mostrarCheckbox || !this.itens || this.itens.length === 0) {
                return []
            }
            return this.itens
                .map(item => this.obterIdItem(item))
                .filter(id => id !== undefined && !this.itensSelecionados.includes(id))
        }
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalItens = filteredItems.length
            this.paginaAtual = 1
        },

        filtrar(data, filtro) {
            let retorno = false
            if (filtro) {
                this.campos.forEach((campo) => {
                    if (campo.filterable) {
                        let tempText
                        if (campo.key.split('.').length === 1) {
                            if (typeof data[campo.key] === 'string') {
                                tempText = data[campo.key].textoNormalizado()
                            } else {
                                tempText = JSON.stringify(
                                    data[campo.key]
                                ).textoNormalizado()
                            }
                        } else {
                            tempText = JSON.stringify(
                                data[campo.key.split('.')[0]]
                            ).textoNormalizado()
                        }
                        retorno =
                            retorno ||
                            tempText.search(filtro.textoNormalizado()) !== -1
                    }
                })
            } else {
                retorno = true
            }
            return retorno
        },

        deepFind(obj, path) {
            let paths = path.split('.')
            let current = obj

            for (let i = 0; i < paths.length; ++i) {
                if (current[paths[i]] === undefined) {
                    return undefined
                } else {
                    current = current[paths[i]]
                }
            }
            return current
        },

        mostrarPadrao(tipo) {
            return tipo !== 'date' && tipo !== 'datetime' && tipo !== 'status'
        },

        obterIdItem(item) {
            return this.deepFind(item, this.propriedadeId)
        },

        isItemSelecionado(item) {
            const id = this.obterIdItem(item)
            return this.itensSelecionados.includes(id)
        },

        toggleSelecionarItem(item) {
            const id = this.obterIdItem(item)
            const index = this.itensSelecionados.indexOf(id)

            if (index > -1) {
                this.itensSelecionados.splice(index, 1)
            } else {
                this.itensSelecionados.push(id)
            }

            this.$emit('selecao-alterada', {
                selecionados: this.itensSelecionados,
                naoSelecionados: this.itensNaoSelecionados
            })
        },

        toggleSelecionarTodos() {
            if (this.todasSelecionadas) {
                this.itensSelecionados = []
            } else {
                this.itensSelecionados = this.itens
                    .map(item => this.obterIdItem(item))
                    .filter(id => id !== undefined)
            }

            this.$emit('selecao-alterada', {
                selecionados: this.itensSelecionados,
                naoSelecionados: this.itensNaoSelecionados
            })
        },

        selecionarTodosItens() {
            if (!this.itens || this.itens.length === 0) {
                return
            }

            this.itensSelecionados = this.itens
                .map(item => this.obterIdItem(item))
                .filter(id => id !== undefined)

            this.$emit('selecao-alterada', {
                selecionados: this.itensSelecionados,
                naoSelecionados: this.itensNaoSelecionados
            })
        }
    },

    mounted() {
        // Selecionar todos os itens automaticamente quando componente for montado
        if (this.mostrarCheckbox && this.itens && this.itens.length > 0) {
            this.selecionarTodosItens()
        }
    },

    watch: {
        itens() {
            if (this.itens) {
                this.totalItens = this.itens.length

                // Selecionar todos os itens automaticamente quando checkbox estiver habilitado
                if (this.mostrarCheckbox) {
                    this.selecionarTodosItens()
                }
            }
        },
        mostrarCheckbox(novoValor) {
            if (!novoValor) {
                this.itensSelecionados = []
                this.$emit('selecao-alterada', {
                    selecionados: [],
                    naoSelecionados: this.itensNaoSelecionados
                })
            } else if (this.itens && this.itens.length > 0) {
                // Quando checkbox é habilitado, selecionar todos
                this.selecionarTodosItens()
            }
        }
    },

    components: {
        appPaginacao: PaginacaoComponent,
        appFiltroTabela: FiltroTabelaComponent
    }
}
</script>
